import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Datasource } from 'ngx-ui-scroll';
import { Subscription } from 'rxjs';

import { EventTypeEnum } from '@commons/enums/event-type.enum';
import { BusinessEvent } from '@commons/models/domain/BusinessEvent';
import { AreaService } from '@commons/services/area/area.service';
import { AreaDrawerService } from '@commons/services/map/drawer/area/area-drawer.service';
import { EventDrawerService } from '@commons/services/map/drawer/event/event-drawer.service';
import { MapService } from '@commons/services/map/map/map.service';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventListComponent implements OnInit, OnDestroy {

  @Input() public listEventType: EventTypeEnum;
  @Input() public data: BusinessEvent[] = [];

  public datasource: any;
  public selectedItemList: BusinessEvent | null;

  public readonly EVENT_TYPE = EventTypeEnum;
  private readonly ComponentSubsc = new Subscription();

  constructor(
    private areaService: AreaService,
    private areaDrawer: AreaDrawerService,
    private eventDrawer: EventDrawerService,
    private mapService: MapService,
  ) {}

  ngOnInit(): void {
    this.initList();
  }

  ngOnDestroy(): void {
    this.ComponentSubsc.unsubscribe();
  }

  public onClickItemList(data: BusinessEvent): void {
    if (this.selectedItemList?.Id === data.Id) {
      this.selectedItemList = null;
      this.areaDrawer.remove();
      this.eventDrawer.removeAll();
      this.mapService.onClickEventList$.next(null as any);
      return;
    }
    this.selectedItemList = { ...data };
    this.mapService.onClickEventList$.next({ data, eventMode: this.listEventType });

    if (this.listEventType === this.EVENT_TYPE.Area) {
      this.onClickArea(data);
    }
    if (this.listEventType === this.EVENT_TYPE.Fuel || this.listEventType === this.EVENT_TYPE.Alarm) {
      this.onClickFuelOrAlarm(data);
    }
  }

  public onClickFuelOrAlarm(data: BusinessEvent): void {
    this.eventDrawer.removeAll();
    this.eventDrawer.drawEvent(data);
    this.eventDrawer.fitBoundsToVisibleEvents();
  }

  private onClickArea(data: BusinessEvent): void {
    const sub = this.areaService.getAreaDetails$(data.ED.Id).subscribe(
      (area) => {
        if (area) {
          this.areaDrawer.remove();
          this.areaDrawer.setArea(area, false, false);
          this.areaDrawer.draw();
          this.areaDrawer.fitBoundsToVisibleArea();
        }
      }
    );
    this.ComponentSubsc.add(sub);
  }

  private initList(): void {
    this.datasource = new Datasource({
      get: (index: number, count: number, success: any) => {
        const dataSlice = this.getDataSlice(index, count);
        success(dataSlice);
      },
      settings: {
        startIndex: 0,
      }
    });
  }

  private getDataSlice(index: number, count: number): BusinessEvent[] {
    const startIndex = index;
    const endIndex = index + count;
    return this.data.slice(startIndex, endIndex);
  }

}
